import React from 'react';
import PropTypes from 'prop-types';

import AggregateShellComponent from "../../../../gd-modules/common/aggregate/aggregate-shell";

export default function AggregateBooleanComponent(options:any, props:any) {

    const value1 = props.value ? props.value.selected : null;
    const value2 = props.value ? !_.isNil(props.value.all) ? props.value.all : props.value.notChecked : null;

    return (
        <AggregateShellComponent options={options} {...props}>
            <div className="aggregate-value aggregate-number">{value1}/{value2}</div>
        </AggregateShellComponent>
    );
}

AggregateBooleanComponent.propTypes = {
    value: PropTypes.shape({
        selected: PropTypes.number,
        all: PropTypes.number,
        notChecked: PropTypes.number,
    })
}